import { createContext } from "react";

export const NewHeaderContext = createContext({} as any);
